// Helper untuk ambil data paket & countdown promo dari backend PHP.
// Default-nya pakai path relatif "/api/index.php" — cocok kalau folder
// /api diupload ke domain yang sama dengan landing page ini.
// Bisa dioverride lewat REACT_APP_API_URL di file .env saat build kalau
// backend-nya di domain/subdomain lain.

const API_BASE = process.env.REACT_APP_API_URL || "/api/index.php";

export const fetchPackages = async () => {
  const res = await fetch(`${API_BASE}?resource=packages`);
  if (!res.ok) throw new Error("Gagal memuat data paket");
  return res.json();
};

export const fetchPromo = async () => {
  const res = await fetch(`${API_BASE}?resource=promo`);
  if (!res.ok) throw new Error("Gagal memuat data promo");
  return res.json();
};

export const fetchStats = async () => {
  const res = await fetch(`${API_BASE}?resource=stats`);
  if (!res.ok) throw new Error("Gagal memuat statistik");
  return res.json();
};

export const fetchTestimoni = async () => {
  const res = await fetch(`${API_BASE}?resource=testimoni`);
  if (!res.ok) throw new Error("Gagal memuat testimoni");
  return res.json();
};

export const fetchContact = async () => {
  const res = await fetch(`${API_BASE}?resource=contact`);
  if (!res.ok) throw new Error("Gagal memuat info kontak");
  return res.json();
};
